import React, {Component} from 'react';
import '../style/applicationPolicy.css';
import FormGroupSelectInput from "./formGroupSelectInput";
import Pagination from "./pagination";
import Notification from "./notification";
import ReactDOM from 'react-dom';
import OverlayIndicator from "./General/overlayIndicator";
import {isAragUser} from "../helpers/functions";
import MultiSelectInput from "./General/multiSelectInput";
import {TABLE_VIEW_OPTIONS} from "../helpers/variables";
import Button from "./button";
import CenteredDots from "./General/centeredDots";
import Loader from "./General/loader/loader";

class Notifications extends Component{

	componentDidUpdate(prevProps, prevState){
		if(prevProps.Store.page !== this.props.Store.page){
			ReactDOM.findDOMNode(this).scrollIntoView();
		}
	}
	render() {
		const updateFormQuestionOptions = this.props.updateFormQuestions
			.filter(item => item.isTopLevel)
			.map(item => ({value: item.machineName, label: item.name}));

		const statusesOptions = this.props.applicationStatuses.statuses
            .map(item => ({value: item.name, label: item.name, machineName: item.name}));

		const caseTypesOptions = this.props.caseTypes
            .map(item => ({value: item.machineName, label: item.name, machineName: item.machineName}));

		const notificationTypesOptions = this.props.Store.notificationTypes.map(item => ({
            value: item.name, label: item.name, machineName: item.name
        }));

		let totalDisplayBoxes = Math.ceil(parseInt(this.props.Store.totalRecords) / parseInt(this.props.Store.selectedView));
		return (
			<div className="row applicationsAndPolicies-wrapper">
				<div className="col-sm-12">
					<div className="row">
						<h2 className="col-sm-12 applicationsAndPolicies-h2">Notifications</h2>
					</div>
					<form className="form-horizontal applicationsAndPolicies-top-wrapper">
                        <MultiSelectInput
                            closeMenuOnSelect={false}
                            isLoading={this.props.fetchingApplicationStatuses}
                            labelClassName={'col-sm-3'}
                            label={'Filter by application statuses'}
                            inputClassName={'col-sm-6'}
                            isMulti={true}
                            placeholder={'Quick search'}
                            handleInputChange={this.props.selectApplicationStatus}
                            value={this.props.Store.selectedStatuses}
                            options={statusesOptions}
                        />
                        <MultiSelectInput
                            closeMenuOnSelect={false}
                            isLoading={this.props.fetchingCaseTypes}
                            labelClassName={'col-sm-3'}
                            label={'Filter by application case types'}
                            inputClassName={'col-sm-6'}
                            isMulti={true}
                            placeholder={'Quick search'}
                            handleInputChange={this.props.selectCaseTypes}
                            value={this.props.Store.selectedCaseTypes}
                            options={caseTypesOptions}
                        />
                        {isAragUser(this.props.userRoles) && (
							<MultiSelectInput
								closeMenuOnSelect={false}
								isLoading={this.props.Store.fetchingNotificationTypes}
								labelClassName={'col-sm-3'}
								label={'Filter by notifications type'}
								inputClassName={'col-sm-6'}
								isMulti={true}
								placeholder={'Quick search'}
								handleInputChange={this.props.selectNotificationTypes}
								value={this.props.Store.selectedNotificationTypes}
								options={notificationTypesOptions}
							/>
                        )}
                        {(isAragUser(this.props.userRoles) && this.props.shouldDisplayUpdateFormQuestionsFilter()) && (
                            <MultiSelectInput
                                closeMenuOnSelect={false}
                                isLoading={this.props.fetchingUpdateFormQuestions}
                                labelClassName={'col-sm-3'}
                                label={'Filter by update form questions'}
                                inputClassName={'col-sm-6'}
                                isMulti={true}
                                placeholder={'Quick search'}
                                handleInputChange={this.props.selectUpdateFormQuestions}
                                value={this.props.Store.selectedUpdateFormQuestions}
                                options={updateFormQuestionOptions}
                            />
                        )}
						<div className="form-group">
							<div className="col-sm-2">
								<FormGroupSelectInput
									Label="View"
									LeftWrapper="col-sm-4"
									Value={this.props.Store.selectedView}
									Name="selectedView"
									HandleInputChange={(evt) => {
                                        this.props.HandleInputChange(evt.target.name, evt.target.value)
                                    }}
									Options={TABLE_VIEW_OPTIONS}
									CenterWrapper="col-sm-8 formGroupSelectInput-select-wrapper"
									RightWrapper="" Required={false}
									SelectStyle={'form-control formGroupSelectInput-select'}
								/>
							</div>
							<div className={'col-sm-6 col-sm-offset-1'}>
								<Button
									clickHandler={this.props.handleFilterClick} wrapper="btn-wrapper"
									btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
									label="Filter"
								/>
								<Button
									clickHandler={this.props.clearNotificationsFilters} wrapper="btn-wrapper"
									btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
									label="Clear filters"
								/>
							</div>
						</div>
						{
							(
								(this.props.Store.fetching === false && !(this.props.Store.notifications.length > 0)) ?
									<div className="form-group">
										<div className="col-sm-7 col-sm-offset-2">
											<div className="col-sm-7 col-sm-offset-5">
												{'No notification to show.'}
											</div>
										</div>
									</div>
									:

									((this.props.Store.fetching)) ?
										<Loader variant="list" />
                                        :
										<div>
											<div style={{position: 'relative'}}>
												<hr className="appFormRefSettings-hr"/>
												<OverlayIndicator
													fetching={
														this.props.Store.fetching &&
														this.props.Store.notifications.length > 0
													}
													wholePage={false}
												/>
												{
													this.props.Store.notifications.map((item, key) => {
														return (
															<Notification
																requestPatchNotification={this.props.requestPatchNotification}
																_getNotificationStatusText={this.props._getNotificationStatusText}
																item={item}
																key={key}
																getSelectedApplication={this.props.getSelectedApplication}
																selectActiveTabNotification={this.props.selectActiveTabNotification}
																receiveApplicationNotification = {this.props.receiveApplicationNotification}
															/>
														);
													})
												}
											</div>
											<Pagination
												PageShift={this.props.PageShift}
												HandleInputChange={this.props.HandleInputChange}
												TotalDisplayBoxes={totalDisplayBoxes}
												TotalRecords={this.props.Store.totalRecords}
												Page={this.props.Store.page}
												SelectedView={parseInt(this.props.Store.selectedView)}
												DataLength={this.props.Store.notifications.length}
											/>
										</div>
							)
						}
					</form>
				</div>
			</div>
		)
	}
};


export default Notifications;